import { getImageUrl } from 'helpers';
import './styles.scss'
import { useRef } from 'react';
import { useAnimation, useAnimationBgParalax } from 'hooks/useAnimation';

import infoBg1 from 'assets/backgrounds/infoBg/infoBg-1.svg'
import infoBg2 from 'assets/backgrounds/infoBg/infoBg-2.svg'
import infoBg3 from 'assets/backgrounds/infoBg/infoBg-3.svg'
import infoBg4 from 'assets/backgrounds/infoBg/infoBg-4.svg'
import infoBg5 from 'assets/backgrounds/infoBg/infoBg-5.svg'

const SingleLayout = ({ children, image, paralaxBg, type, isLoading }) => {
    const container = useRef();
    useAnimation({
        items: ['.single-img', '.single-body'],
        container,
        dependencies: [isLoading],
    })
    useAnimationBgParalax({
        items: ['.single-img__bg'],
        container,
        dependencies: [isLoading],
    }
    )
    const imageUrl = getImageUrl(image)

    let infoBg;
    switch (paralaxBg) {
        case "bg_default":
            infoBg = infoBg1
            break;
        case "bg_default-2":
            infoBg = infoBg2
            break;
        case "bg_socks":
            infoBg = infoBg3
            break;
        case "bg_arow":
            infoBg = infoBg4
            break;
        case "bg_short":
            infoBg = infoBg5
            break;

        default:
            break;
    }

    return (
        <section ref={container} className={`inner-container single ${type === 'left' ? "single--reversed" : ""}`}>
            <div className="single__left">
                <div className='single-img'>
                    {infoBg && <img className='single-img__bg' src={infoBg} alt="" />}
                    <img className='single-img__main' src={imageUrl} alt="" />
                </div>
            </div>
            <div className="single__right">
                {children}
            </div>
        </section>
    )
};

export default SingleLayout;